import { render } from "./ProductReadMore.vue?vue&type=template&id=0b3d9ea6&scoped=true"
import script from "./ProductReadMore.vue?vue&type=script&lang=js"
export * from "./ProductReadMore.vue?vue&type=script&lang=js"

import "./ProductReadMore.vue?vue&type=style&index=0&id=0b3d9ea6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b3d9ea6"]])

export default __exports__